function G2() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        Ґ2 Стратегічна комунікація
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        Ґ2.1 Здатність представляти інтереси закладу дошкільної освіти у відносинах з державними органами, органами місцевого самоврядування, юридичними та фізичними особами
                    </td>
                    <td>
                        Ґ2.1.31 Основи сучасних маркетингових комунікацій, технологій, сутність представницької функції
                    </td>
                    <td>
                        Ґ2.1.У1 Представляти заклад дошкільної освіти, використовуючи сучасні маркетингові комунікації і технології
                    </td>
                </tr>
                <tr>
                    <td>
                        Ґ2.1.32 Інструменти та технології стратегічної комунікації
                    </td>
                    <td>
                        Ґ2.1.У2 Організовувати комунікаційний процес з усіма заінтересованими сторонами
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {G2}